export default "__VITE_ASSET__hCpiK9pW__"